
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "scroll-box": "scroll-box-f885b115",
    "scrollBox": "scroll-box-f885b115"
};
exports.styleSource = ".scroll-box-f885b115{display:block;position:relative;box-sizing:border-box;width:100%;height:100%;overflow:auto}.scroll-box-f885b115::-webkit-scrollbar{width:.5em;height:.5em}.scroll-box-f885b115::-webkit-scrollbar-track{background-color:#fff}.scroll-box-f885b115::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:.25em;background-color:#ddd;transition:all .2s linear}.scroll-box-f885b115:hover::-webkit-scrollbar-thumb{border:1px solid #fff;border-radius:.25em;background-color:#bbb}";
exports.default = exports.styles;
            
module.moduleType = "style";
